import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { List, ListItem, ListItemText } from '@material-ui/core';

const FormDetailDialog = ({ open, handleClose, form }) => (
  <Dialog maxWidth="sm" fullWidth onClose={handleClose} open={open}>
    <DialogTitle>{form?.title || 'Form Details'}</DialogTitle>
    <DialogContent dividers>
      <p>
        <strong>Project:</strong> {form?.safetyProject?.name}
      </p>
      <p>
        <strong>Status:</strong> {form?.isActive ? 'Active' : 'Inactive'}
      </p>
      <p>
        <strong>Questions:</strong>
      </p>
      <List dense>
        {(form?.questions || []).map((q, i) => (
          <ListItem key={q.id || i}>
            <ListItemText primary={`${i + 1}. ${q.text}`} secondary={q.isActive === false ? 'Inactive' : null} />
          </ListItem>
        ))}
      </List>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} color="primary">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

FormDetailDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  form: PropTypes.object
};

export default FormDetailDialog;
